import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const AuthProtectedRoute = () => {
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);

  const render = () => {
    if (!isLoggedIn) {
      return <Outlet />;
    }

    return <Navigate to="/onboarding" />;
  };

  return render();
};

export default AuthProtectedRoute;
